<template>
  <div>
    <form action="#" @submit.prevent="submitForm">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Discrimination/Sexual Misconduct Complaint Form</h1>
            <div id="message" class="alert alert-danger hidden">
              <h3>Could not submit complaint!</h3>
              <ul>
                <li v-for="error in errors" :key="error.name">{{ error.name }}</li>
              </ul>
            </div>
            <div class="radio">
              <div style="font-weight: bold;padding-bottom:10px;">Anonymous?</div>
              <label for="anonymousYES" class="radio-inline">
                <input type="radio" name="anonymous" id="anonymousYES" value="true" v-model="complaint.anonymous">
                YES
              </label>
              <label for="anonymousNO" class="radio-inline">
                <input type="radio" name="anonymous" id="anonymousNO" value="false" v-model="complaint.anonymous">
                NO
              </label>
            </div>
          </div>
        </div>
        <div class="row" :class="{'slide-down': !isAnonymous, 'slide-up': isAnonymous}">
            <div class="col-md-12">
              <h2>Person alleging discrimination/sexual misconduct or person referring the complaint:</h2>
              <hr>
            </div>
            <div class="col-md-6 form-group" id="name-div">
              <label for="name">Name <span class="required">*</span></label>
              <input type="text" class="form-control" name="name" id="name" v-model="complaint.name">
            </div>
            <div class="col-md-6 form-group" id="campusId-div">
              <label for="campusId">Campus ID</label>
              <input type="text" class="form-control" name="campusId" id="campusId" v-model="complaint.campusId">
            </div>
            <div class="col-md-6 form-group" id="department-div">
              <label for="department">Department</label>
              <input type="text" class="form-control" name="department" id="department" v-model="complaint.department">
            </div>
            <div class="col-md-6 form-group" id="email-div">
              <label for="email">Email Address <span class="required">*</span></label>
              <input type="email" class="form-control" name="email" id="email" v-model="complaint.email">
            </div>
            <div class="col-md-12 form-group" id="address-div">
              <label for="address">Address</label>
              <textarea name="address" id="address" class="form-control" v-model="complaint.address"></textarea>
            </div>
            <div class="col-md-6 form-group" id="phoneDay-div">
              <label for="phoneDay">Phone (Daytime)</label>
              <input type="text" class="form-control" name="phoneDay" id="phoneDay" v-model="complaint.phoneDay">
            </div>
            <div class="col-md-6 form-group" id="phoneEvening-div">
              <label for="phoneEvening">Phone (Evening)</label>
              <input type="text" class="form-control" name="phoneEvening" id="phoneEvening" v-model="complaint.phoneEvening">
            </div>
            <div class="col-md-6 form-group" id="status-div">
              <label for="status">University Status <span class="required">*</span></label>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="status" id="statusF" value="FACULTY_STAFF" v-model="complaint.status">
                  Faculty / Staff
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="status" id="statusS" value="STUDENT" v-model="complaint.status">
                  Student
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="status" id="statusO" value="OTHER" v-model="complaint.status">
                  Other (Please specify)
                </label>
              </div>
              <div v-show="isOther">
                <input type="text" name="otherStatus" id="otherStatus" class="form-control" v-model="complaint.otherStatus" >
              </div>
            </div>
        </div>
      </div>
      <div style="background-color: #f0f0f0; margin-bottom: 20px;">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2>Person who is accused of discrimination/sexual misconduct:</h2>
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group" id="accusedName-div">
              <label for="accusedName">Name <span class="required">*</span></label>
              <input type="text" class="form-control" name="accusedName" id="accusedName" v-model="complaint.accused.name">
            </div>
            <div class="col-md-6 form-group" id="accusedTitle-div">
              <label for="accusedTitle">Title</label>
              <input type="text" class="form-control" name="accusedTitle" id="accusedTitle" v-model="complaint.accused.title">
            </div>
            <div class="col-md-6 form-group" id="accusedDepartment-div">
              <label for="accusedDepartment">Department</label>
              <input type="text" class="form-control" name="accusedDepartment" id="accusedDepartment" v-model="complaint.accused.department">
            </div>
            <div class="col-md-6 form-group" id="accusedEmail-div">
              <label for="accusedEmail">Email Address</label>
              <input type="accusedEmail" class="form-control" name="accusedEmail" id="accusedEmail" v-model="complaint.accused.email">
            </div>
            <div class="col-md-12 form-group" id="accussedAddress-div">
              <label for="accussedAddress">Address</label>
              <textarea name="accussedAddress" id="accussedAddress" class="form-control" v-model="complaint.accused.address"></textarea>
            </div>
            <div class="col-md-6 form-group" id="accusedPhone-div">
              <label for="accusedPhone">Phone</label>
              <input type="text" class="form-control" name="accusedPhone" id="accusedPhone" v-model="complaint.accused.phone">
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group" id="accusedStatus-div">
              <label for="accusedStatus">University Status <span class="required">*</span></label>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="accusedStatus" id="accusedStatusF" value="FACULTY_STAFF" v-model="complaint.accused.status">
                  Faculty / Staff
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="accusedStatus" id="accusedStatusS" value="STUDENT" v-model="complaint.accused.status">
                  Student
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="accusedStatus" id="accusedStatusO" value="OTHER" v-model="complaint.accused.status">
                  Other (Please specify)
                </label>
              </div>
              <div v-show="isOtherAccused">
                <input type="text" name="otherAccusedStatus" id="otherAccusedStatus" class="form-control" v-model="complaint.accused.otherStatus" >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12 form-group" id="description-div">
            <label for="description">Describe specific act(s) alleged with name(s), date(s), time(s) and location(s) if possible <span class="required">*</span></label>
            <textarea name="description" id="description" class="form-control" v-model="complaint.description" style="height: 200px;"></textarea>
          </div>
          <div id="basis-div" class="form-group">
            <div class="col-md-12" id="basis">
              <div style="font-weight: bold;">Basis of Discrimination/Sexual Misconduct <span class="required">*</span></div>
            </div>
            <div class="col-md-3">
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="RACE_COLOR" v-model="complaint.basis">
                  Race/Color
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="AGE" v-model="complaint.basis">
                  Age
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="SEXUAL_MISCONDUCT" v-model="complaint.basis">
                  Sexual Misconduct
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="HEIGHT" v-model="complaint.basis">
                  Height
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="RETALIATION" v-model="complaint.basis">
                  Retaliation
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="GENDER" v-model="complaint.basis">
                  Gender
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="WEIGHT" v-model="complaint.basis">
                  Weight
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="NATIONAL_ORIGIN_CREED_ANCESTRY" v-model="complaint.basis">
                  National Origin/Creed/Ancestry
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="RELIGION" v-model="complaint.basis">
                  Religion
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="VETERAN_STATUS" v-model="complaint.basis">
                  Veteran Status
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" name="basis" value="DISABILITY" v-model="complaint.basis">
                  Disability
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group" id="witnesses-div">
            <div style="font-weight: bold;padding-bottom:10px;">Were witnesses present for the alleged behaviour? <span class="required">*</span></div>
            <label class="radio-inline">
              <input type="radio" name="witnesses" value="true" v-model="complaint.hasWitnesses">
              Yes
            </label>
            <label class="radio-inline">
              <input type="radio" name="witnesses" value="false" v-model="complaint.hasWitnesses">
              No
            </label>
          </div>
        </div>
        <div class="row" :class="{'slide-down': hasWitnessesCheck, 'slide-up': !hasWitnessesCheck}">
          <div v-for="witness in complaint.witnesses" :key="witness.position">
            <div class="col-md-5 form-group">
              <label :for="'witnessName'+witness.position" class="witness-name">Name</label>
              <input type="text" :name="'witnessName'+witness.position" :id="'witnessName'+witness.position" v-model="witness.name" class="form-control input-lg">
            </div>
            <div class="col-md-5 form-group">
              <label :for="'witnessContactInfo'+witness.position">Contact Information</label>
              <input type="text" :name="'witnessContactInfo'+witness.position" :id="'witnessContactInfo'+witness.position" v-model="witness.contactInfo" class="form-control input-lg">
            </div>
            <div class="col-md-1" style="padding-top: 29px;">
              <a href="#" class="btn btn-default btn-block btn-lg" @click.prevent="removeWitness(witness.position)"><span class="fa fa-trash-o"></span></a>
            </div>
            <div class="col-md-1" style="padding-top: 29px;">
              <a href="#" class="btn btn-default btn-block btn-lg" @click.prevent="addWitness"><span class="fa fa-plus"></span></a>
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label for="witnessesComments">Comments</label>
            <textarea name="witnessesComments" id="witnessesComments" class="form-control" v-model="complaint.witnessesComments"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group" id="stopAction-div">
            <div style="font-weight: bold;padding-bottom:10px;">If alleging sexual misconduct, did you take any action to stop the sexual misconduct? <span class="required">*</span></div>
            <label class="radio-inline">
              <input type="radio" name="stopAction" value="true" v-model="complaint.stopAction">
              Yes
            </label>
            <label class="radio-inline">
              <input type="radio" name="stopAction" value="false" v-model="complaint.stopAction">
              No
            </label>
          </div>
        </div>
        <div class="row" :class="{'slide-down': ifStopAction, 'slide-up': !ifStopAction}">
          <div class="col-md-12 form-group" id="stopActionDescription-div">
            <label for="stopActionTaken">Please summarize the action taken:</label>
            <textarea name="stopActionTaken" id="stopActionTaken" class="form-control" v-model="complaint.stopActionTaken"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group" id="resolution-div">
            <label for="resolution">How would you like to see the situation resolution? <span class="required">*</span></label>
            <textarea name="resolution" id="resolution" class="form-control" v-model="complaint.resolution"></textarea>
          </div>
          <div class="col-md-12">
            <vue-recaptcha
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              sitekey="6LfyzwQTAAAAAPRpD5oNsRs91TjdvhGkp_v8mfcH">
            </vue-recaptcha>
            <button type="submit" class="btn btn-primary btn-lg" id="submit-btn" style="margin-top: 15px;"><span class="fa fa-envelope"></span> Submit</button>
            <!-- <button class="btn btn-default btn-lg" @click="resetRecaptcha"><span class="fa fa-undo"></span> Reset ReCAPTCHA</button> -->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
let $ = require('jquery')

export default {
  name: 'Home',
  components: {
    VueRecaptcha
  },
  data () {
    return {
      witnessPosition: 1,
      errors: [],
      complaint: {
        anonymous: false,
        name: '',
        campusId: '',
        department: '',
        email: '',
        address: '',
        phoneDay: '',
        phoneEvening: '',
        status: [],
        otherStatus: '',
        description: '',
        basis: [],
        hasWitnesses: '',
        witnesses: [{position: '1', name: '', contactInfo: ''}],
        witnessesComments: '',
        stopAction: '',
        stopActionTaken: '',
        resolution: '',
        accused: {
          name: '',
          title: '',
          department: '',
          email: '',
          address: '',
          phone: '',
          status: [],
          otherStatus: ''
        },
        verification: ''
      }
    }
  },
  computed: {
    isAnonymous: function () {
      if (this.complaint.anonymous === 'true') {
        return true
      }
      return false
    },
    isOther: function () {
      if (this.complaint.status.includes('OTHER')) {
        return true
      }
      return false
    },
    isOtherAccused: function () {
      if (this.complaint.accused.status.includes('OTHER')) {
        return true
      }
      return false
    },
    hasWitnessesCheck: function () {
      if (this.complaint.hasWitnesses === 'true') {
        return true
      }
      return false
    },
    ifStopAction: function () {
      if (this.complaint.stopAction === 'true') {
        return true
      }
      return false
    }
  },
  methods: {
    addWitness: function () {
      let vue = this
      vue.witnessPosition++
      let witness = {position: vue.witnessPosition, name: '', contactInfo: ''}
      vue.complaint.witnesses.push(witness)
      setTimeout(function () {
        let witnessName = 'witnessName' + vue.witnessPosition
        console.log('Looking for ' + witnessName)
        document.getElementById(witnessName).focus()
      }, 100)
    },
    removeWitness: function (position) {
      for (let i = 0; i < this.complaint.witnesses.length; i++) {
        if (this.complaint.witnesses[i].position === position) {
          this.complaint.witnesses.splice(i, 1)
        }
      }
      if (this.complaint.witnesses.length === 0) {
        this.addWitness()
      }
    },
    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    submitForm: function () {
      console.log('Submitting form')
      let vue = this
      vue.errors = []
      let message = document.getElementById('message')
      message.classList.add('hidden')
      document.getElementById('name-div').classList.remove('has-error')
      document.getElementById('email-div').classList.remove('has-error')
      document.getElementById('status-div').classList.remove('has-error')
      document.getElementById('accusedName-div').classList.remove('has-error')
      document.getElementById('accusedStatus-div').classList.remove('has-error')
      document.getElementById('description-div').classList.remove('has-error')
      document.getElementById('basis-div').classList.remove('has-error')
      document.getElementById('witnesses-div').classList.remove('has-error')
      let witnessName = document.getElementsByClassName('witness-name')
      if (witnessName && witnessName[0]) {
        witnessName[0].classList.remove('has-error')
      }
      document.getElementById('stopAction-div').classList.remove('has-error')
      document.getElementById('stopActionDescription-div').classList.remove('has-error')
      document.getElementById('resolution-div').classList.remove('has-error')

      if (vue.complaint.anonymous !== 'true') {
        if (vue.complaint.name.trim() === '') {
          let error = {name: 'If you would like to be anonymous, please select that option otherwise you need to provide a name'}
          vue.errors.push(error)
          let nameDiv = document.getElementById('name-div')
          nameDiv.classList.add('has-error')
        }

        if (vue.complaint.email.trim() === '' || !vue.validateEmail(vue.complaint.email)) {
          let error = {name: 'Please provide a valid email address'}
          vue.errors.push(error)
          let emailDiv = document.getElementById('email-div')
          emailDiv.classList.add('has-error')
        }

        if (vue.complaint.status.length === 0) {
          let error = {name: 'Please specify if you\'re a student, faculty or other'}
          vue.errors.push(error)
          let statusDiv = document.getElementById('status-div')
          statusDiv.classList.add('has-error')
        } else {
          if (vue.complaint.status.includes('OTHER') && vue.complaint.otherStatus.trim() === '') {
            let error = {name: 'Please provide other university status'}
            vue.errors.push(error)
            let statusDiv = document.getElementById('status-div')
            statusDiv.classList.add('has-error')
          }
        }
      }

      if (vue.complaint.accused.name.trim() === '') {
        let error = {name: 'Please specify name of accused person'}
        vue.errors.push(error)
        let accusedNameDiv = document.getElementById('accusedName-div')
        accusedNameDiv.classList.add('has-error')
      }

      if (vue.complaint.accused.status.length === 0) {
        let error = {name: 'Please specify university status of accused person'}
        vue.errors.push(error)
        let accusedStatusDiv = document.getElementById('accusedStatus-div')
        accusedStatusDiv.classList.add('has-error')
      }

      if (vue.complaint.description.trim() === '') {
        let error = {name: 'Please provide reason of complaint'}
        vue.errors.push(error)
        let descriptionDiv = document.getElementById('description-div')
        descriptionDiv.classList.add('has-error')
      }

      if (vue.complaint.basis.length === 0) {
        let error = {name: 'Please provide basis of complaint'}
        vue.errors.push(error)
        let basisDiv = document.getElementById('basis-div')
        basisDiv.classList.add('has-error')
      }

      if (vue.complaint.hasWitnesses === '') {
        let error = {name: 'Please tell us if there\'s witnesses'}
        vue.errors.push(error)
        let witnessesDiv = document.getElementById('witnesses-div')
        witnessesDiv.classList.add('has-error')
      } else if (vue.complaint.hasWitnesses === 'true') {
        if (vue.complaint.witnesses[0].name.trim() === '') {
          let error = {name: 'Please provide name of witness'}
          vue.errors.push(error)
          let witnessesDiv = document.getElementsByClassName('witness-name')
          witnessesDiv[0].classList.add('has-error')
        }
      }

      if (vue.complaint.stopAction === '') {
        let error = {name: 'Please tell us if you did anything to stop it'}
        vue.errors.push(error)
        let stopActionDiv = document.getElementById('stopAction-div')
        stopActionDiv.classList.add('has-error')
      } else if (vue.complaint.stopAction === 'true') {
        if (vue.complaint.stopActionTaken.trim() === '') {
          let error = {name: 'Please tell us if what you did to stop it'}
          vue.errors.push(error)
          let stopActionDiv = document.getElementById('stopActionDescription-div')
          stopActionDiv.classList.add('has-error')
        }
      }

      if (vue.complaint.resolution.trim() === '') {
        let error = {name: 'Please tell us how would you like to see the situation resolved'}
        vue.errors.push(error)
        let resolutionDiv = document.getElementById('resolution-div')
        resolutionDiv.classList.add('has-error')
      }

      if (vue.complaint.verification.trim() === '') {
        let error = {name: 'Please verify that you\'re not a robot'}
        vue.errors.push(error)
      }

      if (vue.errors.length > 0) {
        message.classList.remove('hidden')
        window.scroll(0, 0)
      } else {
        $.post('/discrimination/api/v2/student-services/discrimination/complaints', this.complaint)
          .done(function () {
            console.log('Done')
            vue.$router.push({name: 'Sent'})
          })
          .fail(function (err) {
            console.error('Could not submit complaint: ', err)
            let error = {name: err.responseJSON}
            vue.errors.push(error)
            message.classList.remove('hidden')
            window.scroll(0, 0)
          })
      }

      document.getElementById('submit-btn').blur()
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.complaint.verification = response
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    }
  }
}
</script>

<style>
  .slide-up, .slide-down {
    overflow-y: hidden;
    transition: all .5s ease-in-out;
  }
  .slide-up > div, .slide-down > div {
    transform: translateY(-150%);
    transition: all .4s ease-in-out;
  }
  .slide-down > div {
    transform: translateY(0);
  }
  .slide-down {
    max-height: 1000px;
  }
  .slide-up {
    max-height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue